import React, {useEffect, useState} from "react";
import {FormInput, FormSelect, FormTextarea, Toggle} from "../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as packageJson from "../../package.json";

const voucherValidityOptions = [
  { label: '3 měsíce', value: '3' },
  { label: '6 měsíců', value: '6' },
  { label: '9 měsíců', value: '9' },
  { label: '12 měsíců', value: '12' },
  { label: '1.5 roku', value: '18' },
  { label: '2 roky', value: '24' },
]
export const Settings: React.FC = () => {
  const [defaultVoucherValidity, setDefaultVoucherValidity] = useState<string>(window.localStorage.getItem('depoto_checkout2_default_voucher_validity') || '6')
  const [printers, setPrinters] = useState<string[]>([])
  const [printer, setPrinter] = useState<string | null>(window.localStorage.getItem('printer'))
  const [printer2, setPrinter2] = useState<string | null>(window.localStorage.getItem('printer2'))
  const [printer2byBrowser, setPrinter2byBrowser] = useState<boolean>(
    !!window.localStorage.getItem('printer2byBrowser'),
  )
  const [isUsingComgateTerminal, setIsUsingComgateTerminal] = useState<boolean>(JSON.parse(window.localStorage.getItem('depoto_checkout2_comgate_allowed')))
  const [comgateTerminalIp, setComgateTerminalIp] = useState<string>(window.localStorage.getItem('depoto_checkout2_comgate_ip') || '192.168.0.206')
  const [comgateTerminalPort, setComgateTerminalPort] = useState<string>(window.localStorage.getItem('depoto_checkout2_comgate_port') || '33350')
  const [isUsing2ndWindow, setIsUsing2ndWindow] = useState<boolean>(JSON.parse(window.localStorage.getItem('depoto_checkout2_2nd_window')))
  const [slideshowLinks, setSlideshowLinks] = useState<string>(window.localStorage.getItem('depoto_checkout2_2nd_window_slideshow_links') || '')
  const desktopApp = window._depoto

  useEffect(() => {
    if (desktopApp) {
      setTimeout(() => loadPrinterList(), 500)
      loadPrinterList()
    }
  }, [])

  const selectPrinter = (printerName: string) => {
    setPrinter(printerName)
    if (printerName === '') {
      window.localStorage.removeItem('printer')
    } else {
      window.localStorage.setItem('printer', printerName)
    }
  }

  const selectPrinter2 = (printerName: string) => {
    setPrinter2(printerName)
    if (printerName === '') {
      window.localStorage.removeItem('printer2')
    } else {
      window.localStorage.setItem('printer2', printerName)
    }
  }

  const selectPrinter2ByBrowser = (isChecked: boolean) => {
    setPrinter2byBrowser(isChecked)
    if (!isChecked) {
      window.localStorage.removeItem('printer2byBrowser')
    } else {
      window.localStorage.setItem('printer2byBrowser', 'true')
    }
  }

  const clearCache = () => {
    desktopApp?.nw?.clearCache()
    alert('Cache smazána, restartujte aplikaci')
    setTimeout(() => desktopApp?.nw?.nw?.App?.quit(), 500)
  }

  const loadPrinterListFromNw = async (): Promise<string[]> => {
    return new Promise(resolve => {
      desktopApp?.nw?.win?.getPrinters((p: any[]) => resolve(p.map(d => d.deviceName)))
    })
  }

  const loadPrinterList = async () => {
    let pList: string[] = await desktopApp?.node?.getPrinters() // does not work on ubuntu 18 for some reason
    // console.warn('printers lp: ', pList)
    if (!pList?.length) {
      pList = await loadPrinterListFromNw()
      // console.warn('printers nw: ', pList)
    }
    pList.unshift('')
    setPrinters(pList)
  }

  const updateVoucherValidity = (months: string) => {
    window.localStorage.setItem('depoto_checkout2_default_voucher_validity', months)
    setDefaultVoucherValidity(months)
  }

  const setComgateAllowed = (isAllowed: boolean) => {
    setIsUsingComgateTerminal(isAllowed)
    window.localStorage.setItem('depoto_checkout2_comgate_allowed', JSON.stringify(isAllowed))
  }

  const setComgateIp = (ip: string) => {
    setComgateTerminalIp(ip)
    window.localStorage.setItem('depoto_checkout2_comgate_ip', ip)
  }

  const setComgatePort = (port: string) => {
    setComgateTerminalPort(port)
    window.localStorage.setItem('depoto_checkout2_comgate_port', port)
  }

  const set2ndWindow = (isUsing: boolean) => {
    setIsUsing2ndWindow(isUsing)
    window.localStorage.setItem('depoto_checkout2_2nd_window', JSON.stringify(isUsing))
  }

  const updateSlideshowLinks = (links: string) => {
    setSlideshowLinks(links)
    window.localStorage.setItem('depoto_checkout2_2nd_window_slideshow_links', links)
  }

  const open2ndWindow = () => {
    window.open('/second-display', '_blank')
  }

  return (
    <div className="w-full h-body p-6 flex flex-col overflow-y-auto max-w-3xl mx-auto">
      <h1 className="text-center font-extrabold text-3xl mb-6 uppercase">Nastavení</h1>
      <div className="border border-base-300 rounded-md bg-white w-full p-4">
        <div>
          {!!desktopApp && (
            <div onClick={loadPrinterList}>
              <FormSelect
                options={printers.map(p => ({ label: p, value: p }))}
                value={printer || ''}
                onChange={selectPrinter}
                label={'Výběr tisku účtenky'}
                className={'w-64'}
              />
              <FormSelect
                options={printers.map(p => ({ label: p, value: p }))}
                value={printer2 || ''}
                onChange={selectPrinter2}
                label={'Výběr tisku A4'}
                className={'w-64'}
              />
              {/*<div className="flex items-center gap-2">*/}
              {/*  <label htmlFor="print2byBrowser">Tisk A4 pomocí browser dialogu</label>*/}
              {/*  <input*/}
              {/*    id={'print2byBrowser'}*/}
              {/*    type={'checkbox'}*/}
              {/*    checked={printer2byBrowser}*/}
              {/*    onChange={() => selectPrinter2ByBrowser(!printer2byBrowser)}*/}
              {/*  />*/}
              {/*</div>*/}
              <div>
                <div className="btn btn-primary mt-10" onClick={() => clearCache()}>
                  Smazat cache
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <h2 className="font-semibold text-base-400 text-lg mb-4">
            Nastavení terminálu Comgate NEXGO
          </h2>
          <div className="mb-4">
            <Toggle label={
              <>
                Použít Comgate terminál
              </>
            } value={isUsingComgateTerminal} onChange={e => setComgateAllowed(e)} />
          </div>
          <div>
            <FormInput
              label={'IP adresa Comgate terminálu'}
              isDisabled={!isUsingComgateTerminal}
              value={comgateTerminalIp} onChange={val => setComgateIp(val)} />
            <FormInput
              label={'Port Comgate terminálu'}
              isDisabled={!isUsingComgateTerminal}
              value={comgateTerminalPort} onChange={val => setComgatePort(val) }/>
          </div>
        </div>
        <div>
          <h2>
            2. Okno aplikace
          </h2>
          <div>
            <Toggle label={
              <>
                Použít 2. okno
              </>
            } value={isUsing2ndWindow} onChange={e => set2ndWindow(e)} />
          </div>
          <div>
            {isUsing2ndWindow && (
              <div>
                <div className="btn btn-primary mt-10" onClick={() => open2ndWindow()}>
                  Otevřít 2. okno
                </div>
                <div>
                  <FormTextarea label={'Slideshow URLs'} value={slideshowLinks} onChange={e => updateSlideshowLinks(e)} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <FormSelect
            label={'Doba platnosti prodaných poukazů'}
            value={defaultVoucherValidity}
            options={voucherValidityOptions}
            onChange={val => updateVoucherValidity(val)}
          />
        </div>
        <div>
          <div className="mt-12">
            {!window._depoto && (
              <div>
                <a href="https://depoto.cz/apps" className="btn btn-soft btn-primary font-semibold!" target="_blank">
                  <FontAwesomeIcon icon={['far', 'download']} />
                  Stažení Depoto desktop aplikace
                </a>
              </div>
            )}
          </div>
        </div>
        <div>
          <div className="mt-12">
            {packageJson?.version?.length && (
              <div>
                v{packageJson.version}
                {/*<a href="`https://gitlab.tomatom.cz/depoto/checkout-v2/-/tags/v${packageJson.version}`" className="link font-semibold!" target="_blank">*/}
                {/*  <FontAwesomeIcon icon={['far', 'code']} /> version: */}
                {/*  v{packageJson.version}*/}
                {/*</a>*/}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
